// extracted by mini-css-extract-plugin
export default {"formHeading":"mR-z","form":"nR-z","submitBtn":"oR-z","disabled":"pR-z","input":"qR-z","error":"rR-z","submitMsg":"sR-z","signIn":"tR-z"};